// FooterNew.jsx
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Newsletter from "../newsletter/Newsletter";
import { NavbarContext } from "../contexts/NavbarContext";
import { ABOUT, BLOG, CONTACT, HOME, PRIVACY, PROFILE, RDV, REALISATIONS, SERVICES, TERMS } from "../../config/routes";

import logoPng from "../../images/png/logo/DA_logo_footer.png";
import logoAvif from "../../images/avif/logo/DA_logo_footer.avif";
import logoWebp from "../../images/webp/logo/DA_logo_footer.webp";

import phoneIcon from "../../images/icons/phone.svg";
import emailIcon from "../../images/icons/email.svg";
import localisationIcon from "../../images/icons/localisation.svg";

import "./styles/Footer.css";

const Footer = () => {
  const { t } = useTranslation();
  const { navbarActive } = useContext(NavbarContext);

  return (
    <footer className={`footer2026 ${navbarActive ? "menu-open" : ""}`}>
      <div className="footer2026-top">
        <div className="footer2026-container">
          <div className="footer2026-brand">
            <Link to={HOME} className="footer2026-logoLink" aria-label="Dreamer Agency">
              <picture>
                <source srcSet={logoAvif} type="image/avif" />
                <source srcSet={logoWebp} type="image/webp" />
                <img src={logoPng} alt="Dreamer Agency" className="footer2026-logo" loading="lazy" />
              </picture>
            </Link>

            <p className="footer2026-tagline">
              Studio tech : <strong>Web</strong>, <strong>SaaS</strong>, <strong>Mobile</strong>,{" "}
              <strong>Growth</strong>. On livre propre - et on optimise pour convertir.
            </p>

            <div className="footer2026-ctaRow">
              <Link to={RDV} className="btn btn-primary">Réserver un appel</Link>
              <Link to={SERVICES} className="btn btn-secondary">Voir les services</Link>
            </div>

            <p className="footer2026-note">
              Réponse rapide • Visio Google Meet • Toulouse • Paris / hybride
            </p>
          </div>

          <div className="footer2026-columns">
            <div className="footer2026-card">
              <h3 className="footer2026-h3">{t("footer.contactUs")}</h3>

              <div className="footer2026-contactItem">
                <span className="footer2026-icon">
                  <img src={phoneIcon} alt="" aria-hidden="true" />
                </span>
                <span className="footer2026-contactText">{t("footer.phone")}</span>
              </div>

              <div className="footer2026-contactItem">
                <span className="footer2026-icon">
                  <img src={emailIcon} alt="" aria-hidden="true" />
                </span>
                <a className="footer2026-contactLink" href={`mailto:${t("footer.email")}`}>
                  {t("footer.email")}
                </a>
              </div>

              <div className="footer2026-contactItem">
                <span className="footer2026-icon">
                  <img src={localisationIcon} alt="" aria-hidden="true" />
                </span>
                <span className="footer2026-contactText">{t("footer.localisation")}</span>
              </div>

              <div className="footer2026-miniLinks">
                <Link to={CONTACT} className="footer2026-miniLink">{t("footer.contact")}</Link>
                <Link to={REALISATIONS} className="footer2026-miniLink">Réalisations</Link>
              </div>
            </div>

            <div className="footer2026-card">
              <h3 className="footer2026-h3">{t("footer.company")}</h3>
              <ul className="footer2026-list">
                <li><Link to={ABOUT} className="footer2026-link">{t("footer.about")}</Link></li>
                <li><Link to={SERVICES} className="footer2026-link">Services</Link></li>
                <li><Link to={REALISATIONS} className="footer2026-link">Réalisations</Link></li>
                <li><Link to={PROFILE} className="footer2026-link">Profil développeur</Link></li>
                <li><Link to={BLOG} className="footer2026-link">{t("footer.blog")}</Link></li>
              </ul>

              <div className="footer2026-divider" />

              <h3 className="footer2026-h3">{t("footer.legal")}</h3>
              <ul className="footer2026-list">
                <li><Link to={PRIVACY} className="footer2026-link">{t("footer.confidentiality")}</Link></li>
                <li><Link to={TERMS} className="footer2026-link">{t("footer.terms")}</Link></li>
              </ul>
            </div>

            <div className="footer2026-card">
              <h3 className="footer2026-h3">{t("footer.joinNewsletter")}</h3>
              <p className="footer2026-muted">
                Une fois par mois : tips produit/dev, SEO/Tracking, retours d’expérience.
              </p>

              <Newsletter customClass="footer2026-newsletter" />

              <p className="footer2026-muted footer2026-small">
                {t("footer.note")}
              </p>

              <div className="footer2026-ctaSmall">
                <Link to={RDV} className="btn btn-tertiary">Réserver un appel →</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer2026-bottom">
        <div className="footer2026-container footer2026-bottomInner">
          <span className="footer2026-bottomText">
            © {new Date().getFullYear()} Dreamer Agency. Tous droits réservés.
          </span>
          <span className="footer2026-bottomText">
            Built with care • <Link to={PRIVACY} className="footer2026-bottomLink">Privacy</Link> •{" "}
            <Link to={TERMS} className="footer2026-bottomLink">Terms</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
